// API Configuration - uses current origin in production, env var in development
const getApiUrl = () => {
  // In production, use the same origin as the frontend
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return `${window.location.origin}/api`;
  }
  // In development, use the environment variable
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiUrl();
